<template>
  <div data-tour-scope="setting-notifications">
    <v-main>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          v-resize="onResize"
          justify-center
          align-center
        >
          <v-card
            width="100%"
            outlined
            elevation-0
          >
            <v-toolbar
              flat
              class="border_bottom"
              shaped
            >
              <v-toolbar-title>Impostazioni Notifiche Push</v-toolbar-title>
              <v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
              <v-spacer />
            </v-toolbar>


            <v-data-table
              :headers="headers"
              class="elevation-0 cellanowrap"
              :hide-default-header="isMobile || mobileCards"
              :class="{ mobile: isMobile, 'table-cards': mobileCards }"
              hide-default-footer
              disable-pagination
              disable-sort
              item-key="item._id"
              data-tour="table"
            >
              <template #body>
                <!-- telefono: il servizio diventa una card, il form di configurazione resta dentro la card -->
                <tbody v-if="mobileCards" class="setnotif-cards">
                  <tr>
                    <td :colspan="headers.length" class="px-3 py-1">
                      <key-value-card>
                        <template #title>
                          <span class="d-inline-flex align-center">
                            <v-avatar size="24px" tile class="mr-2"><img :src="require('@/assets/images/communication/firebase.svg')" alt="Firebase Push" /></v-avatar>
                            Firebase Push Notifications
                          </span>
                        </template>
                        <template #actions>
                          <v-switch v-if="firebasePush" v-model="firebasePush.active" color="primary" class="mt-0 pt-0 mr-2" hide-details @change="saveSetting(0)" />
                          <v-btn small icon color="primary" data-tour="expand" :title="checkpresenza(0) ? 'Chiudi' : 'Impostazioni'" @click="extension(0)">
                            <v-icon>{{ checkpresenza(0) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
                          </v-btn>
                        </template>
                        <firebase-push-panel
                          v-if="checkpresenza(0)"
                          :intestazione="false"
                          :modello="firebasePush"
                          :available-channels="availableChannels"
                          :notification-types="notificationTypes"
                          :test-token.sync="testToken"
                          :test-message.sync="testMessage"
                          data-tour="settings"
                          @save="saveSetting(0)"
                          @upload="handleFileUpload"
                          @test="sendTestNotification"
                          @check="openConnectionCheck('firebase_push')"
                        />
                      </key-value-card>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(0) }" @click="extension(0)">
                    <td class="pr-0" style="width: 40px">
                      <v-btn small icon data-tour="expand" :title="checkpresenza(0) ? 'Chiudi' : 'Impostazioni'" @click.stop="extension(0)">
                        <v-icon>{{ checkpresenza(0) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-avatar size="32px" tile>
                        <img :src="require('@/assets/images/communication/firebase.svg')" alt="Firebase Push" />
                      </v-avatar>
                      Firebase Push Notifications
                    </td>
                    <td @click.stop>
                      <v-switch v-if="firebasePush" v-model="firebasePush.active" color="primary" class="mt-0" hide-details @change="saveSetting(0)" />
                    </td>
                  </tr>
                  <tr v-if="checkpresenza(0)" class="as-expanded">
                    <td :colspan="headers.length" class="py-3">
                      <firebase-push-panel
                          :modello="firebasePush"
                          :available-channels="availableChannels"
                          :notification-types="notificationTypes"
                          :test-token.sync="testToken"
                          :test-message.sync="testMessage"
                          data-tour="settings"
                          @save="saveSetting(0)"
                          @upload="handleFileUpload"
                          @test="sendTestNotification"
                          @check="openConnectionCheck('firebase_push')"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card>
          <v-snackbar
            v-model="snackbar.snackbar"
            :color="snackbar.color"
            :multi-line="snackbar.mode === 'multi-line'"
            :timeout="snackbar.timeout"
            :vertical="snackbar.mode === 'vertical'"
          >
            {{ snackbar.text }}
            <v-btn
              dark
              text
              @click="snackbar.snackbar = false"
            >
              Close
            </v-btn>
          </v-snackbar>
        </v-layout>
      </v-container>
    </v-main>
    <TourOverlay :tour="tour" />
    <marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { uuid } from 'vue-uuid';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createNotificationsSettingsTourSteps, stopNotificationsSettingsTour } from './notifications-settings-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import FirebasePushPanel from './components/FirebasePushPanel.vue';
import MarketplaceConnectionCheck from './components/MarketplaceConnectionCheck.vue';

export default {
	name: 'Notifications',
	components: {
		TourOverlay,
		KeyValueCard,
		FirebasePushPanel,
		MarketplaceConnectionCheck,
	},
	setup() {
		return { tour: useTour(createNotificationsSettingsTourSteps(), { onStop: stopNotificationsSettingsTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},

	data() {
		return {
			// UI state
			isMobile: false,
			// riquadri di configurazione aperti (indice del servizio)
			selected: [],
			// verifica connessione: verifica le impostazioni salvate
			connectionCheck: { open: false, service: 'firebase_push' },
			testToken: '',
			testMessage: '',

			// Snackbar
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},

			headers: [
				{ text: '', width: '50px', sortable: false },
				{ text: 'Servizio', sortable: false },
				{ text: 'Status', sortable: false },
			],

			// Canali disponibili
			availableChannels: [
				{
					value: 'web',
					label: 'Web (Nuxt3)',
					icon: 'mdi-web',
				},
				{
					value: 'ios',
					label: 'iOS',
					icon: 'mdi-apple',
				},
				{
					value: 'android',
					label: 'Android',
					icon: 'mdi-android',
				},
			],

			// Tipi di notifiche per e-commerce
			notificationTypes: [
				{
					value: 'order_placed',
					label: 'Ordine ricevuto',
					description: 'Notifica quando un cliente effettua un ordine',
					icon: 'mdi-cart-check',
					color: 'success',
				},
				{
					value: 'order_shipped',
					label: 'Ordine spedito',
					description: 'Notifica quando un ordine viene spedito',
					icon: 'mdi-truck-delivery',
					color: 'info',
				},
				{
					value: 'order_delivered',
					label: 'Ordine consegnato',
					description: 'Notifica quando un ordine viene consegnato',
					icon: 'mdi-package-variant-closed',
					color: 'success',
				},
				{
					value: 'order_cancelled',
					label: 'Ordine annullato',
					description: 'Notifica quando un ordine viene annullato',
					icon: 'mdi-cancel',
					color: 'error',
				},
				{
					value: 'payment_confirmed',
					label: 'Pagamento confermato',
					description: 'Notifica quando il pagamento è confermato',
					icon: 'mdi-credit-card-check',
					color: 'success',
				},
				{
					value: 'payment_failed',
					label: 'Pagamento fallito',
					description: 'Notifica quando il pagamento fallisce',
					icon: 'mdi-credit-card-remove',
					color: 'error',
				},
				{
					value: 'low_stock',
					label: 'Scorte in esaurimento',
					description: 'Notifica quando le scorte stanno per esaurirsi',
					icon: 'mdi-alert',
					color: 'warning',
				},
				{
					value: 'back_in_stock',
					label: 'Prodotto disponibile',
					description: 'Notifica quando un prodotto torna disponibile',
					icon: 'mdi-package-variant',
					color: 'info',
				},
				{
					value: 'price_drop',
					label: 'Riduzione prezzo',
					description: 'Notifica quando il prezzo di un prodotto diminuisce',
					icon: 'mdi-tag-arrow-down',
					color: 'success',
				},
				{
					value: 'new_message',
					label: 'Nuovo messaggio',
					description: 'Notifica per nuovi messaggi dal supporto',
					icon: 'mdi-message-text',
					color: 'primary',
				},
				{
					value: 'promocode',
					label: 'Codice promozionale',
					description: 'Notifica per nuovi codici sconto disponibili',
					icon: 'mdi-ticket-percent',
					color: 'purple',
				},
				{
					value: 'wishlist_sale',
					label: 'Offerta wishlist',
					description: 'Notifica quando prodotti in wishlist vanno in offerta',
					icon: 'mdi-heart-box',
					color: 'pink',
				},
			],

			// Firebase Push Notifications service
			firebasePush: {
				active: false,
				setting: {
					credentials_url: '',
					client_email: '',
					private_key: '',
					project_id: '',
					server_key: '',
					sender_id: '',
					vapid_key: '',
					channels: [],
					notification_types: [],
					ios: {
						bundle_id: '',
						team_id: '',
					},
					android: {
						package_name: '',
						priority: 'high',
					},
					web: {
						app_url: '',
						icon_url: '',
						api_key: '',           // apiKey
						auth_domain: '',       // authDomain
						storage_bucket: '',    // storageBucket
						app_id: '',            // appId
						measurement_id: '',    // measurementId (opzionale)
					},
				},
				type: 'notifications',
				service: 'firebase_push',
			},
		};
	},

	async created() {
		this.setPreload(true);
		let promises = [];
		promises.push(this.fetchSettings());
		promises.push(this.fetchService(['firebase_push']));
		await Promise.all(promises);
		this.setPreload(false);

		// Load Firebase Push configuration if exists
		let firebasePush = _.find(this.getServices, set => {
			return set.service === 'firebase_push';
		});

		if (firebasePush) {
			this.firebasePush = {
				active: firebasePush.active || false,
				setting: {
					credentials_url: firebasePush.setting?.credentials_url || '',
					project_id: firebasePush.setting?.project_id || '',
					server_key: firebasePush.setting?.server_key || '',
					sender_id: firebasePush.setting?.sender_id || '',
					vapid_key: firebasePush.setting?.vapid_key || '',
					channels: firebasePush.setting?.channels || [],
					notification_types: firebasePush.setting?.notification_types || [],
					client_email: firebasePush.setting?.client_email || '',
					private_key: firebasePush.setting?.private_key || '',
					ios: {
						bundle_id: firebasePush.setting?.ios?.bundle_id || '',
						team_id: firebasePush.setting?.ios?.team_id || '',
					},
					android: {
						package_name: firebasePush.setting?.android?.package_name || '',
						priority: firebasePush.setting?.android?.priority || 'high',
					},
					web: {
						api_key: firebasePush.setting?.web?.api_key || '',
						auth_domain: firebasePush.setting?.web?.auth_domain || '',
						storage_bucket: firebasePush.setting?.web?.storage_bucket || '',
						app_id: firebasePush.setting?.web?.app_id || '',
						measurement_id: firebasePush.setting?.web?.measurement_id || '',
						app_url: firebasePush.setting?.web?.app_url || '',
						icon_url: firebasePush.setting?.web?.icon_url || '',
					},
				},
				type: 'notifications',
				service: 'firebase_push',
			};
		}
	},

	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getPreload: 'settings/getPreload',
			getSettings: 'settings/getSetting',
			getServices: 'services/getServices',
		}),
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',
			destroyData: 'settings/destroyData',
			setService: 'services/updateData',
		}),

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},

		async handleFileUpload(file) {
			if (file && file.name) {
				const formData = new FormData();
				formData.append('file', file, file.name);
				formData.append('uuid', uuid.v4());

				try {
					const response = await axios.post(`${this.getUrl}multimedias/uploadfile`, formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
							Authorization: `Bearer ${this.getToken}`,
						},
					});

					this.firebasePush.setting.credentials_url = response.data.url;
					this.$forceUpdate();

					this.snackbar.color = 'success';
					this.snackbar.text = 'File caricato con successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 3000;
				} catch (err) {
					this.snackbar.color = 'error';
					this.snackbar.text = 'Errore durante il caricamento del file';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				}
			}
		},

		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		async sendTestNotification() {
			this.setPreload(true);
			try {
				await axios.post(
					`${this.getUrl}notifications/test`,
					{
						token: this.testToken,
						message: this.testMessage,
					},
					{
						headers: { Authorization: `Bearer ${this.getToken}` },
					},
				);

				this.snackbar.color = 'success';
				this.snackbar.text = 'Notifica di test inviata con successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
			} catch (err) {
				this.snackbar.color = 'error';
				this.snackbar.text = err.response?.data?.error || 'Errore durante l\'invio della notifica';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
			} finally {
				this.setPreload(false);
			}
		},

		async saveSetting(item) {
			let payload;

			switch (item) {
			case 0:
				payload = this.firebasePush;
				break;
			}

			this.setPreload(true);
			let url = 'services/update';

			axios
				.post(`${this.getUrl}${url}`, payload, {
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(({ data }) => {
					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Configurazione salvata con successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					let errorMessage = 'Errore durante il salvataggio';

					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errorMessage = errors.map(e => e.msg).join(', ');
							} else {
								errorMessage = errors;
							}
						}

						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}

					this.snackbar.color = 'error';
					this.snackbar.text = errorMessage;
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.setPreload(false);
				});
		},

		extension(item) {
			let check = this.selected.includes(item);
			if (!check) {
				this.selected.push(item);
			} else {
				let index = this.selected.indexOf(item);
				this.selected.splice(index, 1);
			}
		},

		checkpresenza(item) {
			return this.selected.includes(item);
		},
	},

};
</script>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
.active {
	background-color: #f5f5f5;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.setnotif-cards,
.setnotif-cards tr {
	display: block;
	width: 100%;
}
.setnotif-cards tr,
.setnotif-cards tr:hover {
	background: transparent !important;
}
.setnotif-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.setnotif-cards tr:first-child td {
	padding-top: 12px !important;
}
.setnotif-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.setnotif-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
